import React from "react";

/**
 * Base skeleton block. Compose via className, or `style` for values
 * Tailwind classes can't express (e.g. arbitrary % widths).
 */
const Skeleton = ({ className = "", style }) => (
  <div className={`animate-pulse rounded-md bg-muted ${className}`} style={style} />
);

export default Skeleton;

/** Repeats render(index) `count` times — kills Array.from({length}).map(...) boilerplate everywhere. */
export const SkeletonGroup = ({ count = 1, render }) => (
  <>{Array.from({ length: count }, (_, i) => render(i))}</>
);

/** One or more lines of "text". Last line is shorter by default, like real paragraphs do. */
export const SkeletonText = ({ lines = 1, lastLineWidth = "60%", className = "" }) => (
  <div className={`space-y-2 ${className}`}>
    <SkeletonGroup
      count={lines}
      render={(i) => (
        <Skeleton
          key={i}
          className="h-4 w-full"
          style={i === lines - 1 && lines > 1 ? { width: lastLineWidth } : undefined}
        />
      )}
    />
  </div>
);

/** Circular placeholder — avatars, icons in a circle, etc. */
export const SkeletonAvatar = ({ className = "h-10 w-10" }) => (
  <Skeleton className={`rounded-full flex-shrink-0 ${className}`} />
);

/** Pill-shaped placeholder for buttons. */
export const SkeletonButton = ({ className = "h-9 w-24" }) => (
  <Skeleton className={`rounded-lg ${className}`} />
);

/** Card chrome — centralizes the bg/border/padding so it's consistent everywhere it's used. */
export const SkeletonCard = ({ className = "", children }) => (
  <div className={`bg-card border border-border rounded-lg p-5 ${className}`}>
    {children}
  </div>
);